export const SET_ALL_ACHIEVEMENTS_DATA = 'SET_ALL_ACHIEVEMENTS_DATA'
export const SET_SINGLE_ACHIEVEMENT_DATA = 'SET_SINGLE_ACHIEVEMENT_DATA'
export const EDIT_ACHIEVEMENT_DATA = 'EDIT_ACHIEVEMENT_DATA'
export const SET_TOTAL_ACHIEVEMENTS = 'SET_TOTAL_ACHIEVEMENTS'
export const SET_USER_SCORE = 'SET_USER_SCORE'
export const SET_LOADING = 'SET_LOADING'
export const SET_RESULTS_LOADING = 'SET_RESULTS_LOADING'
export const SET_COMPANY_TEAMS_DATA = 'SET_COMPANY_TEAMS_DATA'
